<template>
    <div>
        <v-card v-if="stationLocation" class="ma-3 pa-5">
            <v-row class="pa-3">
                <h3>Sensor variables</h3>
            </v-row>
            <v-divider class="my-3"/>
            <v-text-field v-if="stationLocation.sensor_variables['ats']"
                          v-model="stationLocation.sensor_variables['ats'].value" label="ATS"/>
            <v-text-field v-if="stationLocation.sensor_variables['ets']"
                          v-model="stationLocation.sensor_variables['ets'].value" label="ETS"/>
            <v-text-field v-if="stationLocation.sensor_variables['corrected_ats']"
                          v-model="stationLocation.sensor_variables['corrected_ats'].value" label="Corrected ATS"/>
            <v-text-field v-if="stationLocation.sensor_variables['corrected_ets']"
                          v-model="stationLocation.sensor_variables['corrected_ets'].value" label="Corrected ETS"/>
            <h3>Sensors</h3>
            <v-card class="my-9" v-for="sensor in stationLocation.sensor_variables.sensors" :key="sensor.id">
                <v-row class="pa-3">
                    <span class="sensor-alias">{{ sensor.alias }}</span>
                    <v-text-field :disabled="variable.disabled" class="mx-3" v-for="variable in sensor.variables" :key="variable.id || variable.name"
                                  :label="variable.name" v-model="variable.value"/>
                </v-row>
            </v-card>
            <v-btn class="mt-3" color="primary" @click="updateLocation">Save</v-btn>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'StationLocationSensorVariableCard',
    data() {
        return {};
    },
    computed: {
        ...mapState('stationLocation', ['stationLocation']),
    },
    methods: {
        ...mapActions('stationLocation', ['updateStationLocationVariables']),
        async updateLocation() {
            await this.updateStationLocationVariables({probeId: this.stationLocation.station_id, locationId: this.stationLocation.id, variables: this.stationLocation.sensor_variables});
        }
    },
};
</script>

<style scoped>

.sensor-alias {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
    font-weight: 600;
    width: 150px;
    line-break: anywhere;
}

</style>